import { render, staticRenderFns } from "./EnrollmentDetailsDialog.vue?vue&type=template&id=39b2bfb0&scoped=true&"
import script from "./EnrollmentDetailsDialog.vue?vue&type=script&lang=ts&"
export * from "./EnrollmentDetailsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EnrollmentDetailsDialog.vue?vue&type=style&index=0&id=39b2bfb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b2bfb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarTitle } from 'vuetify/lib/components/VAppBar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VAlert,VAppBar,VAppBarTitle,VCard,VCardText,VDivider,VForm})
